(function () {
  'use strict';

  /* @ngdoc object
   * @name adminCommanderDiscretion
   * @description
   *
   */
  angular
    .module('adminCommanderDiscretion', [
      'ui.router'
    ]);
}());
